import React from 'react';
import type { ReactSwitchProps } from 'react-switch';
import Switch from './switch';

type LabeledSwitchProps = {
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  labelPosition?: 'left' | 'right';
  containerClassName?: string;
  labelClassName?: string;
  tooltip?: string;
} & Omit<ReactSwitchProps, 'checked' | 'onChange'>;

const LabeledSwitch: React.FC<LabeledSwitchProps> = ({
  label,
  checked,
  onChange,
  labelPosition = 'left',
  containerClassName = 'react-switch-container',
  labelClassName = 'mb-0',
  tooltip,
  ...switchProps
}) => {
  const switchElement = (
    <Switch checked={checked} onChange={onChange} className="react-switch" {...switchProps} />
  );

  const labelElement = (
    <label className={labelClassName} title={tooltip}>
      {label}
    </label>
  );

  return (
    <div className={containerClassName}>
      {labelPosition === 'left' ? (
        <>
          {labelElement}
          {switchElement}
        </>
      ) : (
        <>
          {switchElement}
          {labelElement}
        </>
      )}
    </div>
  );
};

export default LabeledSwitch;
